import Image from 'next/image';
import Link from 'next/link';
import { RefObject } from 'react';

import { UiKitLabelBase } from '@/fo/ui/kit/label/base';
import { UiProductButtonBuy } from '@/fo/ui/product/button/buy';

import { Product } from '../types';

import { styles } from './UiProductTileMini.styles';

type NativeElement = React.HTMLAttributes<HTMLDivElement>;

export interface UiProductTileMiniProps {
  ref?: RefObject<HTMLDivElement | null>;
  product: Product;
  onClick?: () => void;
  onAddToCart?: NativeElement['onClick'];
  isInCart?: boolean;
}

export function UiProductTileMini({
  ref,
  product,
  onAddToCart,
  isInCart,
  onClick,
  ...props
}: UiProductTileMiniProps) {
  const slots = styles();
  const { image, link, title, subtitle, alt, labels, prices } = product;

  const hasPrice = prices && prices.price !== null && prices.price > 0;

  return (
    <div
      ref={ref}
      className={slots.base()}
      {...props}
    >
      {hasPrice ? (
        <Link
          href={link}
          className={slots.imageWrapper()}
          onClick={onClick}
        >
          <Image
            className={slots.image()}
            alt={alt || 'packshot'}
            width={120}
            height={120}
            src={image}
          />
          {labels &&
            labels.map(({ name, color }) => (
              <UiKitLabelBase
                className={slots.label()}
                key={name}
                customColor={color}
              >
                {name}
              </UiKitLabelBase>
            ))}
        </Link>
      ) : (
        <div className={slots.imageWrapper()}>
          <Image
            className={slots.image()}
            alt={alt || 'packshot'}
            width="120"
            height="120"
            src={image}
          />
          {labels &&
            labels.map(({ name, color }) => (
              <UiKitLabelBase
                className={slots.label()}
                key={name}
                customColor={color}
              >
                {name}
              </UiKitLabelBase>
            ))}
        </div>
      )}

      <div className={slots.contentWrapper()}>
        {hasPrice ? (
          <Link
            href={link}
            className={slots.text()}
            onClick={onClick}
          >
            <div className={slots.title()}>{title}</div>
            {subtitle && <p className={slots.subtitle()}>{subtitle}</p>}
          </Link>
        ) : (
          <div className={slots.text()}>
            <div className={slots.title()}>{title}</div>
            {subtitle && <p className={slots.subtitle()}>{subtitle}</p>}
          </div>
        )}

        {prices && prices.price !== null && prices.price > 0 && (
          <UiProductButtonBuy
            isInCart={isInCart}
            price={prices.price}
            oldPrice={prices.oldPrice}
            onClick={onAddToCart}
          />
        )}
      </div>
    </div>
  );
}
